"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignedDocuments = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const signed_user_documents_thunk_1 = require("../../../../../reducers/slices/document/thunks/signed_user_documents_thunk");
const doshx_controls_web_1 = require("doshx_controls_web");
const doshx_controls_web_2 = require("doshx_controls_web");
const routes_1 = require("../../../../../constants/routes");
const main_1 = require("../../../../../reducers/slices/main");
const delete_document_thunk_1 = require("../../../../../reducers/slices/document/thunks/delete/delete_document_thunk");
const document_overview_thunk_1 = require("../../../../../reducers/slices/document/thunks/document_overview_thunk");
const document_status_modal_1 = require("./document_status_modal");
const react_router_dom_1 = require("react-router-dom");
const SignedDocuments = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { user } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { signedUserDocuments, signedUserDocumentsCount } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const userEmail = user === null || user === void 0 ? void 0 : user.email;
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [itemsPerPage, setItemsPerPage] = (0, react_1.useState)(10);
    const [sort, setSort] = (0, react_1.useState)({
        key: "date_sort",
        direction: "desc", // Newest first
    });
    // Fetch documents with pagination params
    const fetchDocuments = (page, size) => {
        if (userEmail) {
            dispatch((0, signed_user_documents_thunk_1.signed_user_documents_thunk)({ email: userEmail, page: page.toString(), size: size.toString() }));
        }
    };
    (0, react_1.useEffect)(() => {
        fetchDocuments(currentPage, itemsPerPage);
    }, [userEmail]);
    // Create clean data objects with only primitive values for display, but keep original doc reference
    const tableData = react_1.default.useMemo(() => {
        return (signedUserDocuments || []).map((doc) => {
            var _a;
            const documentId = String(doc._id || "");
            const documentName = String(doc.name || "");
            // Extract sender name from populated user_id object
            const senderName = doc.user_id ? `${doc.user_id.name || ""} ${doc.user_id.surname || ""}`.trim() : "";
            const documentStatus = String(doc.status || "");
            const signedDate = (_a = doc === null || doc === void 0 ? void 0 : doc.signedAt) !== null && _a !== void 0 ? _a : doc === null || doc === void 0 ? void 0 : doc.updatedAt;
            const formattedDate = doshx_controls_web_2.Utilities.formatDateTime(signedDate);
            return Object.assign(Object.assign({}, doc), { _id: documentId, name: documentName, sender: senderName, status: documentStatus, date: formattedDate, date_sort: signedDate ? new Date(signedDate).getTime() : 0 });
        });
    }, [signedUserDocuments]);
    // Handle row click to show status modal
    const handleRowClick = react_1.default.useCallback((document) => {
        dispatch((0, main_1.setContentModal)({
            title: document.name,
            content: (react_1.default.createElement(document_status_modal_1.DocumentStatusModal, { document: document, onView: () => {
                    dispatch((0, main_1.setContentModal)(null));
                    if ((document === null || document === void 0 ? void 0 : document.status) === "DRAFT") {
                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${document === null || document === void 0 ? void 0 : document._id}`);
                    }
                    else {
                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENT_ROUTE}/${document === null || document === void 0 ? void 0 : document._id}/link`);
                    }
                }, canDelete: document.user_id === (user === null || user === void 0 ? void 0 : user._id), onDelete: () => {
                    dispatch((0, main_1.setContentModal)(null));
                    dispatch((0, main_1.setMessageModal)({
                        title: "Confirm!",
                        messages: [`Are you sure you want to delete document '${document.name}'?`],
                        buttons: [
                            {
                                label: "Cancel",
                                backgroundColor: "bg-white",
                                textColor: "text-primary",
                                borderColor: "border-primary",
                                onClick: () => {
                                    dispatch((0, main_1.setMessageModal)(null));
                                },
                            },
                            {
                                label: "Confirm",
                                onClick: () => {
                                    dispatch((0, delete_document_thunk_1.delete_document_thunk)({
                                        type: "document",
                                        data: { _id: document._id },
                                    })).then((data) => {
                                        if (data.payload) {
                                            dispatch((0, document_overview_thunk_1.document_overview_thunk)());
                                            // Refresh signed documents list
                                            fetchDocuments(currentPage, itemsPerPage);
                                        }
                                    });
                                    dispatch((0, main_1.setMessageModal)(null));
                                },
                            },
                        ],
                    }));
                }, onClose: () => {
                    dispatch((0, main_1.setContentModal)(null));
                } })),
        }));
    }, [dispatch, navigate, currentPage, itemsPerPage]);
    // Calculate pagination
    const totalPages = Math.ceil(signedUserDocumentsCount / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 px-2 sm:px-0" },
        react_1.default.createElement("h2", null, "Signed Documents"),
        react_1.default.createElement(doshx_controls_web_1.TableControl, { columns: [
                { displayKey: "name", label: "Name" },
                { displayKey: "sender", label: "Sender" },
                { displayKey: "status", label: "Status" },
                { displayKey: "date_sort", label: "Date", formatter: (row) => row.date },
            ], data: tableData, sort: {
                value: sort,
                onChange: (newSort) => setSort(newSort),
            }, onRowClicked: handleRowClick }),
        signedUserDocumentsCount > 0 && (react_1.default.createElement("div", { className: "flex items-center justify-between bg-white p-4 rounded-md" },
            react_1.default.createElement("div", { className: "flex items-center gap-4" },
                react_1.default.createElement("span", { className: "text-sm text-gray-600" }, "Items per page:"),
                react_1.default.createElement(doshx_controls_web_1.DropdownControl, { size: "small", options: [
                        { label: "10", value: "10" },
                        { label: "25", value: "25" },
                        { label: "50", value: "50" },
                    ], value: itemsPerPage.toString(), onChange: (value) => {
                        const newSize = parseInt(value);
                        setItemsPerPage(newSize);
                        setCurrentPage(1);
                        fetchDocuments(1, newSize);
                    }, borderColor: "border-gray-300", textColor: "text-black" })),
            react_1.default.createElement("div", { className: "flex items-center gap-2 text-sm text-gray-600" },
                react_1.default.createElement("span", null,
                    "Showing ",
                    startIndex + 1,
                    " to ",
                    Math.min(endIndex, signedUserDocumentsCount),
                    " of ",
                    signedUserDocumentsCount,
                    " documents")),
            react_1.default.createElement("div", { className: "flex items-center gap-2" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Previous", size: "small", onClick: () => {
                        if (currentPage > 1) {
                            const newPage = currentPage - 1;
                            setCurrentPage(newPage);
                            fetchDocuments(newPage, itemsPerPage);
                        }
                    }, backgroundColor: currentPage === 1 ? "bg-gray-300" : "bg-primary", textColor: "text-white" }),
                react_1.default.createElement("span", { className: "text-sm text-gray-600" },
                    "Page ",
                    currentPage,
                    " of ",
                    totalPages),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Next", size: "small", onClick: () => {
                        if (currentPage < totalPages) {
                            const newPage = currentPage + 1;
                            setCurrentPage(newPage);
                            fetchDocuments(newPage, itemsPerPage);
                        }
                    }, backgroundColor: currentPage === totalPages ? "bg-gray-300" : "bg-primary", textColor: "text-white" }))))));
};
exports.SignedDocuments = SignedDocuments;
